/**
 * Addendum Service — API client for report addendum operations.
 */
import apiClient from './apiClient';
import { API_URL } from '../config';

export interface GenerateAddendumRequest {
  report_id: number;
  dictated_text: string;
  reason?: 'correction' | 'supplement' | 'clarification';
  session_id?: string;
}

export interface GenerateAddendumResponse {
  addendum_id: number;
  report_id: number;
  addendum_text: string;
  reason: string | null;
  confidence: number;
  status: string;
}

export interface AddendumResponse {
  id: number;
  report_id: number;
  addendum_text: string;
  reason: string | null;
  created_by: number;
  created_at: string | null;
  finalized_at: string | null;
  finalized_by: number | null;
  is_finalized: boolean;
}

export interface AddendumListResponse {
  addenda: AddendumResponse[];
  total: number;
}

const generateAddendum = async (request: GenerateAddendumRequest): Promise<GenerateAddendumResponse> => {
  const response = await apiClient.post(`${API_URL}/addenda/generate`, request);
  return response.data;
};

const listAddenda = async (reportId: number): Promise<AddendumListResponse> => {
  const response = await apiClient.get(`${API_URL}/reports/${reportId}/addenda`);
  return response.data;
};

const addendumService = {
  generateAddendum,
  listAddenda,
};

export default addendumService;
